var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],staticClass:"back-to-top",class:{ visible: _vm.isVisible },attrs:{"title":"回到顶部"},on:{"click":_vm.scrollToTop}},[_c('i',{staticClass:"fas fa-chevron-up"})])
}
var staticRenderFns = []

export { render, staticRenderFns }